<template>
  <div class="container">
    <publicacion-modal
      :publicacion-id="selectedPublicacionId"
    ></publicacion-modal>
    <show-paid-or-unpaid-data :paidInfo="false">
      <info>Con el plan Starter tienes acceso a las 10 últimas entradas.</info>
    </show-paid-or-unpaid-data>
    <publicaciones-filters @search="this.getPublicaciones" />
    <c-card title="Publicaciones Municipales">
      <div class="d-flex justify-content-end">
        <show-paid-or-unpaid-data>
          <json-excel
            :data="PublicacionesMunicipales"
            :fields="publicacionesFields"
            name="publicaciones-municipales"
          >
            <c-primary-button> Descargar </c-primary-button>
          </json-excel>
        </show-paid-or-unpaid-data>
      </div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Fecha de publicación oficial</th>
            <th>Estado</th>
            <th>Municipio</th>
            <th>Titulo</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="Publicacion in PublicacionesMunicipales"
            :key="Publicacion.id"
          >
            <td>
              {{ Publicacion.fecha_publicacion_oficial_formatted }}
            </td>
            <td>{{ Publicacion.state }}</td>
            <td>{{ Publicacion.city }}</td>
            <td>{{ Publicacion.title }}</td>
            <td class="text-nowrap">
              <button
                class="btn btn-secondary btn-sm ms-2 d-inline-block"
                @click.prevent="selectedPublicacionId = Publicacion.id"
                data-bs-toggle="modal"
                data-bs-target="#publicacionMunicialModal"
                title="Ver"
              >
                <i class="fa-solid fa-eye"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </c-card>
  </div>
</template>
<script>
import CCard from "@/components/CCard.vue";
import JsonExcel from "vue-json-excel3";
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import PublicacionesFilters from "@/components/PublicacionesFilters.vue";
import { all } from "@/services/publicaciones_municipales";
import ShowPaidOrUnpaidData from "@/components/showPaidOrUnpaidData";
import PublicacionModal from "@/components/Publicaciones/PublicacionMunicipalModal";
import Info from "@/components/Alerts/Info.vue";
import { userPlanIsActive } from "@/services/users";

export default {
  components: {
    Info,
    CCard,
    PublicacionesFilters,
    JsonExcel,
    CPrimaryButton,
    ShowPaidOrUnpaidData,
    PublicacionModal,
  },
  data() {
    return {
      PublicacionesMunicipales: [],
      selectedPublicacionId: null,
      publicacionesFields: {
        "Fecha de publicación oficial": "fecha_publicacion_oficial_formatted",
        Estado: "state",
        Municipio: "city",
        Giro: "giro",
        Tipo: "tipo",
        Título: "title",
        "Palabras clave": "keywords",
        Observaciones: "observations",
        "Fecha de aplicación": "fecha_entrada_en_vigor_formatted",
        link: "link",
        páginas: "pages",
      },
    };
  },
  mounted() {
    // this.getPublicaciones();
  },
  methods: {
    getPublicaciones() {
      const queryParams = this.$route.query;
      all(queryParams)
        .then(async (response) => {
          const planIsActive = await userPlanIsActive();
          // TODO refactor to handle this in backend
          planIsActive
            ? (this.PublicacionesMunicipales = response.data)
            : (this.PublicacionesMunicipales = response.data.slice(0, 10));
        })
        .catch(() => {
          alert("No pudimos cargar las Publicaciones Municipales");
        });
    },
  },
};
</script>
